<template>
  <div class="mainDiv">
    <el-row>
      <el-col :span="2">
        &nbsp;
      </el-col>
      <el-col :span="20">
        <div class="main_title">田字格
          <div class="sub_title">无需注册帐户，全部免费使用，所见即所得，可导出PDF文件</div>
        </div>
      </el-col>
      <el-col :span="2">
        &nbsp;
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="2">
        &nbsp;
      </el-col>
      <el-col :span="20">
        <div class="template_group_div">练字字贴
        </div>
      </el-col>
      <el-col :span="2">
        &nbsp;
      </el-col>
    </el-row>

    <el-row v-for="(item,index) in templateList" :key="item.templateId" v-if="index%4==0">
      <el-col :span="2">
        &nbsp;
      </el-col>
      <el-col :span="5" v-if="index<=templateList.length-1">
        <li>
          <div class="div_item">
            <el-image lazy="lazy" class="preview_img" :src="require('../images/'+ templateList[index].imageUrl)"/>
            <div class="item-title">
              模板编号:{{ templateList[index].templateId }}
            </div>
            <div class="generate-button">
              <el-button type="success" @click="gotoTemplate(templateList[index].templateId)">去生成</el-button>
            </div>
          </div>
        </li>
      </el-col>

      <el-col :span="5" v-if="index+1<=templateList.length-1">
        <li>
          <div class="div_item">
            <el-image lazy="lazy" class="preview_img" :src="require('../images/'+ templateList[index+1].imageUrl)"/>
            <div class="item-title">
              模板编号:{{ templateList[index + 1].templateId }}
            </div>
            <div class="generate-button">
              <el-button type="success" @click="gotoTemplate(templateList[index+1].templateId)">去生成</el-button>
            </div>
          </div>
        </li>
      </el-col>

      <el-col :span="5" v-if="index+2<=templateList.length-1">
        <li>
          <div class="div_item">
            <el-image lazy="lazy" class="preview_img" :src="require('../images/'+ templateList[index+2].imageUrl)"/>
            <div class="item-title">
              模板编号:{{ templateList[index + 2].templateId }}
            </div>
            <div class="generate-button">
              <el-button type="success" @click="gotoTemplate(templateList[index+2].templateId)">去生成</el-button>
            </div>
          </div>
        </li>
      </el-col>

      <el-col :span="5" v-if="index+3<=templateList.length-1">
        <li>
          <div class="div_item">
            <el-image lazy="lazy" class="preview_img" :src="require('../images/'+ templateList[index+3].imageUrl)"/>
            <div class="item-title">
              模板编号:{{ templateList[index + 3].templateId }}
            </div>
            <div class="generate-button">
              <el-button type="success" @click="gotoTemplate(templateList[index+3].templateId)">去生成</el-button>
            </div>
          </div>
        </li>
      </el-col>

      <el-col :span="2">

      </el-col>
    </el-row>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainDiv {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  font-family: "楷体", KaiTi, SimKai;
}

.main_title {
  font-size: 48px;
  font-weight: normal;
  line-height: 48px;
  margin: 0 0 20px;
  padding: 0 0 20px;
  text-align: center;
  border-bottom: 1px solid black;
}

.sub_title {
  font-size: 24px;
  font-weight: normal;
  line-height: 24px;
  display: inline-block;
  color: dodgerblue;
}

.template_group_div {
  font-size: 26px;
  font-weight: normal;
  margin: 0 0 10px;
  padding: 0 0 10px;
  text-align: center;
}

li {
  list-style-type: none;
}

.div_item {
  -webkit-box-shadow: 0px 0px 10px #cccccc;
  -moz-box-shadow: 0px 0px 10px #cccccc;
  box-shadow: 0px 0px 10px #cccccc;
  width: 80%;
  border-radius: 1em;
  padding: 10px;
  display: inline-grid;
  justify-content: center;
}

.image_item {
  -webkit-box-shadow: 0px 0px 10px #cccccc;
  -moz-box-shadow: 0px 0px 10px #cccccc;
  box-shadow: 0px 0px 10px #cccccc;
  width: 80%;
  border-radius: 1em;
  padding: 10px;
  justify-content: center;
}

.preview_img {
  width: 100%;
  height: 100%;
}

.item-title {
  border-top: 1px solid black;
  padding-top: 10px;
  font-size: 17px;
  text-align: center;
}

.generate-button {
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}


.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}


.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


<script>
import axios from "axios";

export default {
  name: "templateList",
  data() {
    return {
      templateList: []
    };
  },
  created() {
  },
  methods: {
    gotoTemplate(tempId) {
      this.$router.push({path: '/templateEdit', query: {templateId: tempId}})
    },
    loadTemplates() {
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/loadTemplates.do"
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.templateList = resp.data.data;
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.loadTemplates();
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/templateList.vue